var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserPlus = function SvgUserPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0M8 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0m4 5c-6.014 0-8 2.25-8 6.75Q4 21 6 21h8.758a4.5 4.5 0 1 0 3.812-7c-1.216-1.333-3.296-2-6.57-2m4.164 2.653C15.236 14.191 13.894 14 12 14c-4.698 0-6 1.174-6 4.75q.001.163.007.25h8.02a4.498 4.498 0 0 1 2.136-4.347M19 18h2v1h-2v2h-1v-2h-2v-1h2v-2h1z",
    clipRule: "evenodd"
  })));
};
export default SvgUserPlus;